import styled, { css } from 'styled-components'
import { Image, Row, Column } from '@sainsburys-tech/bolt'
import { ChevronIcon } from '@sainsburys-tech/bolt-icons'
import { themeContract } from './M0013.theme.contract'
import { colorToLunaToken, remCalculator } from '../../../../helpers/theming/utilities'

const getTextColor = (props) =>
  props.textTheme === 'dark'
    ? props.theme.color.palette[themeContract[props.theme.channel].textTheme.dark]
    : props.theme.color.monochrome.white

export const StyledWrapper = styled(Row)`
  display: flex;
  position: relative;
  flex-basis: auto;
  margin-bottom: ${(props) => props.theme.size.spacing.lg};
  border-radius: ${(props) => props.theme.size.border.radius.base};
  overflow: hidden;
`
export const StyledImage = styled(Image)`
  position: absolute;
  right: 0;
  z-index: 1;
  background-repeat: no-repeat;
  object-fit: cover;
  ${(props) =>
    props.theme.channel === 'sainsburys' &&
    css`
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        height: 100%;
      }
    `}
`

export const StyledTextContainer = styled(Column)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  text-align: center;
  padding: ${(props) => props.theme.size.spacing.lg};
  z-index: 2;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    height: 350px;
  }

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].lg}) {
    ${(props) => css`
      padding: ${props.theme.size.spacing.lg} ${props.theme.size.spacing['2xl']};
    `}
  }
`

export const StyledHeading = styled.h1`
  color: ${(props) =>
    props.theme.channel === 'nectar' && props.textTheme === 'dark'
      ? props.theme.color.palette['purple-90']
      : getTextColor(props)};
`

export const StyledSubHeading = styled.h4`
  color: ${(props) => getTextColor(props)};
`

export const StyledSponsorCopy = styled.p`
  padding: 0 ${remCalculator(20)};
  margin: ${remCalculator(20)} 0;
  color: ${(props) => getTextColor(props)};
`

export const StyledChevron = styled(ChevronIcon)`
  margin-left: auto;
  fill: currentColor;
  position: relative;
`

export const StyledLinksContainer = styled(Column)`
  display: flex;
  z-index: 2;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.color.monochrome.white};
  padding: ${(props) => props.theme.size.spacing.lg} 0;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    background-color: transparent;
  }
`

export const StyledLink = styled.a`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 5px 10px;
  min-height: 46px;
  text-decoration: none;
  border-radius: ${(props) => props.theme.size.border.radius.base};
  z-index: 1;
  color: ${(props) => getTextColor(props)};
  background-color: ${(props) => colorToLunaToken(props.backgroundColor, props.theme)};

  &:hover {
    filter: brightness(1.1);
    transition: 0.2s linear;
    ${(props) =>
      props.theme.channel === 'sainsburys' &&
      css`
        color: ${getTextColor(props)};
      `}
  }

  &:active {
    filter: brightness(0.8);
  }
`

export const StyledSignpost = styled(Column)`
  margin-bottom: 10px;
  list-style: none;
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].xs}) {
    &:nth-child(odd) {
      ${StyledLink} {
        margin-right: ${(props) => props.theme.size.spacing.md};
      }
    }

    &:nth-child(even) {
      ${StyledLink} {
        margin-left: ${(props) => props.theme.size.spacing.md};
      }
    }
  }
`

export const StyledSignpostsContainer = styled(Row)`
  margin: 0;
  flex: 0 0 100%;
  max-width: 100%;
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    margin: 0 -${(props) => props.theme.size.spacing.lg};
    max-width: none;
  }
  @media screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].sm}) {
    padding-right: 0;
  }

  ${(props) =>
    props.signpostsEvenOdd === 'even' &&
    css`
      ${StyledLink}:nth-last-child(-n + 2) {
        margin-bottom: 0;
      }
    `}

  ${(props) =>
    props.signpostsEvenOdd === 'odd' &&
    css`
      ${StyledLink}:last-child {
        margin-bottom: 0;
      }
    `}
`
